const SummaryList = [
  {
    name: 'File.Encrypt.File',
    count: 0,
    desc_en: 'Encrypt file',
    desc_zh: '加密文件'
  },
  {
    name: 'File.StealBy.File',
    count: 0,
    desc_en: 'Write sensitive data to file',
    desc_zh: '将敏感数据写入文件'
  },
  {
    name: 'Network.Encrypt.Socket',
    count: 0,
    desc_en: 'Encrypt network traffic',
    desc_zh: '加密网络通信'
  },
  {
    name: 'Comm.StealBy.SMS',
    count: 0,
    desc_en: 'Steal sensitive info via SMS',
    desc_zh: '通过短信盗取私密信息'
  },
  {
    name: 'Web.Clear.WebObject',
    count: 0,
    desc_en: 'Clear browser history',
    desc_zh: '清除浏览器历史'
  },
  {
    name: 'Android.Write.UI.80',
    count: 0,
    desc_en: 'Activity injection',
    desc_zh: 'Activity注入'
  },
  {
    name: 'Android.Read.Clipboard',
    count: 0,
    desc_en: 'Read clipboard',
    desc_zh: '读取剪切板'
  },
  {
    name: 'Android.Write.Clipboard',
    count: 0,
    desc_en: 'Write clipboard',
    desc_zh: '擦写坚强版'
  },
  {
    name: 'Android.Remove.Package',
    count: 0,
    desc_en: 'Get the app uninstallment broadcast',
    desc_zh: '获取删除软件广播'
  },
  {
    name: 'Android.Install.Package',
    count: 0,
    desc_en: 'Get the app installment broadcast',
    desc_zh: '获取安装软件广播'
  },
  {
    name: 'Android.Update.Package',
    count: 0,
    desc_en: 'Enable/Disable system apps',
    desc_zh: '开启/关闭系统软件'
  },
  {
    name: 'Android.Broadcast',
    count: 0,
    desc_en: "Update other apps' setting",
    desc_zh: '升级其他软件的设置'
  },
  {
    name: 'Android.Read.Package',
    count: 0,
    desc_en: 'Retrieve an XML file from a package',
    desc_zh: '从包中取回XML文件'
  },
  {
    name: 'Evade.Monitor.Behavior',
    count: 0,
    desc_en: 'Detect the sandbox/customized ROM',
    desc_zh: '发现沙盒/自定义ROM'
  },
  {
    name: 'Evade.Detect.Package',
    count: 0,
    desc_en: 'Close the mobile anti-virus app',
    desc_zh: '关闭移动杀毒软件'
  },
  {
    name: 'Network.StealBy.Socket',
    count: 1,
    desc_en: 'Stole personal information from Network',
    desc_zh: '通过网络偷窃隐私信息'
  },
  {
    name: 'File.Other.Package.000',
    count: 0,
    desc_en: 'Check certain file existence',
    desc_zh: '检查特定文件是否存在'
  },
  {
    name: 'File.Read.Package.000',
    count: 1,
    desc_en: 'List/check installed packages',
    desc_zh: '排列/检查已安装包'
  },
  {
    name: 'File.Read.File.000',
    count: 0,
    desc_en: 'Read file',
    desc_zh: '读取文件'
  },
  {
    name: 'File.Read.File.001',
    count: 3,
    desc_en: "Read other app's data",
    desc_zh: '读取其它软件数据'
  },
  {
    name: 'File.Read.File.002',
    count: 3,
    desc_en: 'Read sensitive file',
    desc_zh: '读取敏感文件'
  },
  {
    name: 'File.Write.File.001',
    count: 0,
    desc_en: "Write other app's data",
    desc_zh: '擦写其它软件数据'
  },
  {
    name: 'File.Write.File.002',
    count: 0,
    desc_en: 'Write to sensitive file',
    desc_zh: '擦写敏感文件'
  },
  {
    name: 'File.Exec.File.000',
    count: 2,
    desc_en: 'Execute released file',
    desc_zh: '执行释放文件'
  },
  {
    name: 'File.Write.Package.000',
    count: 1,
    desc_en: 'Install package',
    desc_zh: '安装包'
  },
  {
    name: 'File.Write.Package.001',
    count: 2,
    desc_en: 'Install 3rd party package',
    desc_zh: '安装第三方包'
  },
  {
    name: 'File.Delete.Package.000',
    count: 0,
    desc_en: 'Uninstall package',
    desc_zh: '删除包'
  },
  {
    name: 'File.Read.ContentProvider.000',
    count: 1,
    desc_en: 'Read from ContentProvider',
    desc_zh: '读取ContentProvider'
  },
  {
    name: 'File.Write.ContentProvider.000',
    count: 1,
    desc_en: 'Insert into ContentProvider',
    desc_zh: '插入到ContentProvider'
  },
  {
    name: 'File.Delete.ContentProvider.000',
    count: 1,
    desc_en: 'Delete from ContentProvider',
    desc_zh: '从ContentProvider中删除'
  },
  {
    name: 'File.Update.ContentProvider.000',
    count: 0,
    desc_en: 'Modify ContentProvider',
    desc_zh: '修改ContentProvider'
  },
  {
    name: 'File.Delete.File.000',
    count: 1,
    desc_en: 'Delete file',
    desc_zh: '删除文件'
  },
  {
    name: 'File.Read.Asset.000', //name: 'File.Read.Asset' ,
    count: 1,
    desc_en: "Read the file from the apk's asset directory",
    desc_zh: '从apk的asset路径读取文件'
  },
  {
    name: 'File.Rename.File.000', //name: 'File.Rename.File' ,
    count: 0,
    desc_en: 'Rename the file',
    desc_zh: '重命名文件'
  },
  {
    name: 'Process.Read.Process.000',
    count: 1,
    desc_en: 'Get running process',
    desc_zh: '获取运行中进程'
  },
  {
    name: 'Process.Read.SysSetting.000',
    count: 0,
    desc_en: 'Get memory information',
    desc_zh: '获取内存信息'
  },
  {
    name: 'Process.Terminate.Process.000',
    count: 2,
    desc_en: 'Terminate process (system/non-system)',
    desc_zh: '终止进程 (系统/非系统)'
  },
  {
    name: 'Process.Terminate.Process.001',
    count: 2,
    desc_en: 'Restart package',
    desc_zh: '重启包'
  },
  {
    name: 'Process.Write.User.000',
    count: 3,
    desc_en: 'Set UID/GID',
    desc_zh: '设置 UID/GID'
  },
  {
    name: 'Process.Read.User.000',
    count: 3,
    desc_en: 'Check privilege',
    desc_zh: '检查权限'
  },
  {
    name: 'Process.Read.User.001',
    count: 0,
    desc_en: 'Get current UID(user id)',
    desc_zh: '获取当前UID(用户ID)'
  },
  {
    name: 'Process.Exec.Process.000',
    count: 2,
    desc_en: 'Exec command',
    desc_zh: '执行命令'
  },
  {
    name: 'Process.Exec.Process.001',
    count: 3,
    desc_en: 'Exec risky command',
    desc_zh: '执行危险命令'
  },
  {
    name: 'Process.Exec.Process.002',
    count: 2,
    desc_en: 'Launch process',
    desc_zh: '开启命令'
  },
  {
    name: 'Process.Exec.Process.003',
    count: 2,
    desc_en: 'Launch service',
    desc_zh: '开启服务'
  },
  {
    name: 'Process.Exec.Process.004',
    count: 2,
    desc_en: 'Launch activity',
    desc_zh: '开启Activity'
  },
  {
    name: 'Process.Exec.Process.010',
    count: 1,
    desc_en: 'Load dex',
    desc_zh: '加载dex'
  },
  {
    name: 'Process.Exec.Process.023',
    count: 0,
    desc_en: 'Load dex',
    desc_zh: '加载dex'
  },
  {
    name: 'Process.Exec.Process.011',
    count: 1,
    desc_en: 'Load so',
    desc_zh: '加载so'
  },
  {
    name: 'Process.Exec.Process.012',
    count: 1,
    desc_en: 'Load jar',
    desc_zh: '加载jar'
  },
  {
    name: 'Process.Exec.Process.020',
    count: 2,
    desc_en: 'Load external dex',
    desc_zh: '加载外部dex'
  },
  {
    name: 'Process.Exec.Process.021',
    count: 2,
    desc_en: 'Load external so',
    desc_zh: '加载外部so'
  },
  {
    name: 'Process.Exec.Process.022',
    count: 2,
    desc_en: 'Load external jar',
    desc_zh: '加载外部jar'
  },
  {
    name: 'Process.Read.Package.000',
    count: 0,
    desc_en: 'Get all package launch counts',
    desc_zh: '获取所有包开启计数'
  },
  {
    name: 'Process.Read.Package.001',
    count: 0,
    desc_en: 'Get all package usage status',
    desc_zh: '获取所有包使用统计'
  },
  {
    name: 'Process.Write.Process.000',
    count: 3,
    desc_en: 'Process injection',
    desc_zh: '进程注入'
  },
  {
    name: 'Network.Read.File.000',
    count: 0,
    desc_en: 'File upload',
    desc_zh: '上传文件'
  },
  {
    name: 'Network.Write.File.001',
    count: 0,
    desc_en: 'File download',
    desc_zh: '下载文件'
  },
  {
    name: 'Network.Write.Socket.000',
    count: 0,
    desc_en: 'HTTP GET request',
    desc_zh: 'HTTP GET 请求'
  },
  {
    name: 'Network.Write.Socket.100',
    count: 0,
    desc_en: 'HTTP POST request',
    desc_zh: 'HTTP POST 请求'
  },
  {
    name: 'Network.Write.Socket.010',
    count: 0,
    desc_en: 'HTTPS GET request',
    desc_zh: 'HTTPS GET 请求'
  },
  {
    name: 'Network.Write.Socket.110',
    count: 0,
    desc_en: 'HTTPS POST request',
    desc_zh: 'HTTPS POST 请求'
  },
  {
    name: 'Network.Read.Socket.300',
    count: 1,
    desc_en: 'Listen socket',
    desc_zh: '监听socket'
  },
  {
    name: 'Network.Write.Socket.300',
    count: 1,
    desc_en: 'Connect socket',
    desc_zh: '链接socket'
  },
  {
    name: 'Network.Write.Socket.200',
    count: 0,
    desc_en: 'HTTP requests (generic)',
    desc_zh: 'HTTP请求 (普通)'
  },
  {
    name: 'Network.Write.Socket.210',
    count: 1,
    desc_en: 'HTTPS requests (generic)',
    desc_zh: 'HTTPS请求 (普通)'
  },
  {
    name: 'Network.Write.Socket.400',
    count: 0,
    desc_en: 'Socket send (generic)',
    desc_zh: 'Socket发送 (普通)'
  },
  {
    name: 'Network.Read.Socket.400',
    count: 0,
    desc_en: 'Socket recv (generic)',
    desc_zh: 'Socket接收 (普通)'
  },
  {
    name: 'Network.Write.Socket.500',
    count: 0,
    desc_en: 'File URL send',
    desc_zh: '发送文件URL'
  },
  {
    name: 'Network.Read.Socket.500',
    count: 0,
    desc_en: 'File URL read',
    desc_zh: '读取文件URL'
  },
  {
    name: 'Network.StealBy.Socket.600',
    count: 0,
    desc_en: 'Steal sensitive via network',
    desc_zh: '通过网络偷窃敏感信息'
  },
  {
    name: 'Network.Read.Socket.600',
    count: 0,
    desc_en: 'DNS query',
    desc_zh: '查询DNS'
  },
  {
    name: 'Socket.StealBy.Socket.65536',
    count: 1,
    desc_en: 'Steal by socket',
    desc_zh: '偷取socket'
  },
  {
    name: 'Comm.Read.SMS.200',
    count: 2,
    desc_en: 'Read SMS inbox',
    desc_zh: '读取短信收件箱'
  },
  {
    name: 'Comm.Write.SMS.200',
    count: 3,
    desc_en: 'Insert into SMS inbox',
    desc_zh: '插入到短信收件箱'
  },
  {
    name: 'Comm.Delete.SMS.200',
    count: 3,
    desc_en: 'Delete from SMS inbox',
    desc_zh: '删除短信收件箱内的文件'
  },
  {
    name: 'Comm.Read.SMS.201',
    count: 2,
    desc_en: 'Read SMS from SIM',
    desc_zh: '从SIM卡读取短信'
  },
  {
    name: 'Comm.Write.SMS.201',
    count: 3,
    desc_en: 'Insert SMS into SIM',
    desc_zh: '插入短信到SIM卡中'
  },
  {
    name: 'Comm.Delete.SMS.201',
    count: 3,
    desc_en: 'Delete SMS from SIM',
    desc_zh: '删除SIM卡内短信'
  },
  {
    name: 'Comm.Read.SMS.202',
    count: 2,
    desc_en: 'Query SMS',
    desc_zh: '查询短信'
  },
  {
    name: 'Comm.Write.SMS.202',
    count: 3,
    desc_en: 'Send SMS',
    desc_zh: '发送短信'
  },
  {
    name: 'Comm.Intercept.SMS.200',
    count: 3,
    desc_en: 'Intercept SMS',
    desc_zh: '拦截短信'
  },
  {
    name: 'Comm.Write.PhoneCall.100',
    count: 0,
    desc_en: 'Make phone call',
    desc_zh: '拨打电话'
  },
  {
    name: 'Comm.Intercept.PhoneCall.100',
    count: 0,
    desc_en: 'Intercept phone call',
    desc_zh: '拦截电话'
  },
  {
    name: 'Comm.Write.PhoneCall.000',
    count: 0,
    desc_en: 'Read call record',
    desc_zh: '读取通话记录'
  },
  {
    name: 'Comm.Read.Contact.000',
    count: 2,
    desc_en: 'Read contacts',
    desc_zh: '读取通讯录'
  },
  {
    name: 'Comm.Write.Contact.000',
    count: 0,
    desc_en: 'Insert contacts',
    desc_zh: '擦写通讯录'
  },
  {
    name: 'Comm.Delete.Contact.000',
    count: 0,
    desc_en: 'Delete contacts',
    desc_zh: '删除通讯录'
  },
  {
    name: 'Comm.Read.Contact.500',
    count: 1,
    desc_en: 'Read phone number',
    desc_zh: '读取电话号码'
  },
  {
    name: 'Comm.Read.PhoneInfo.501',
    count: 2,
    desc_en: 'Read SIM card SN number',
    desc_zh: '读取SIM卡SN号码'
  },
  {
    name: 'Comm.Read.PhoneInfo.502',
    count: 0,
    desc_en: 'Read phone subscriber ID',
    desc_zh: '读取手机订阅ID'
  },
  {
    name: 'Comm.Read.Contact.503',
    count: 0,
    desc_en: 'Read phone voice mail number',
    desc_zh: '读取手机语音信箱号码'
  },
  {
    name: 'Comm.Write.Contact.503',
    count: 0,
    desc_en: 'Write phone voice mail number',
    desc_zh: '擦写手机语音信箱号码'
  },
  {
    name: 'Comm.Read.Contact.504',
    count: 0,
    desc_en: 'Read phone voice message count',
    desc_zh: '读取手机语音信箱计数信息'
  },
  {
    name: 'Comm.Read.Contact.505',
    count: 0,
    desc_en: 'Read phone tag number',
    desc_zh: '读取手机标签号码'
  },
  {
    name: 'Comm.Read.PhoneInfo.506',
    count: 0,
    desc_en: 'Get the operator name',
    desc_zh: '获取服务商名字'
  },
  {
    name: 'Comm.Update.Comm.601',
    count: 0,
    desc_en: "Change the component's setting",
    desc_zh: '修改Component设置'
  },
  {
    name: 'Comm.Write.Priority.000', //name: 'Comm.Write.Priority' ,
    count: 0,
    desc_en: "Set the interFilter's priority",
    desc_zh: '设置interFilter的优先级'
  },
  {
    name: 'Comm.Write.Priority', //name: 'Comm.Write.Priority' ,
    count: 0,
    desc_en: "Set the interFilter's priority",
    desc_zh: '设置interFilter的优先级'
  },
  {
    name: 'Comm.Register.Receiver.000', //name: 'Comm.Register.Receiver' ,
    count: 0,
    desc_en: 'Register the receiver dynamically',
    desc_zh: '动态注册接收器'
  },
  {
    name: 'Comm.Register.Receiver', //name: 'Comm.Register.Receiver' ,
    count: 0,
    desc_en: 'Register the receiver dynamically',
    desc_zh: '动态注册接收器'
  },
  {
    name: 'Web.Write.WebObject.000',
    count: 0,
    desc_en: 'Disable browser JS status',
    desc_zh: '关闭浏览器JS支持'
  },
  {
    name: 'Web.Write.WebObject.001',
    count: 0,
    desc_en: 'Enable browser JS status',
    desc_zh: '开启浏览器JS支持'
  },
  {
    name: 'Web.Write.WebObject.010',
    count: 2,
    desc_en: 'Change browser setting',
    desc_zh: '改变浏览器设置'
  },
  {
    name: 'Web.Write.WebObject.020',
    count: 2,
    desc_en: 'Change Webkit property',
    desc_zh: '改变Webkit优先级'
  },
  {
    name: 'Web.Write.WebObject.030',
    count: 2,
    desc_en: 'Insert browsing history',
    desc_zh: '擦写浏览记录'
  },
  {
    name: 'Web.Delete.WebObject.030',
    count: 2,
    desc_en: 'Delete browsing history',
    desc_zh: '删除浏览记录'
  },
  {
    name: 'Web.Read.WebObject.032',
    count: 0,
    desc_en: 'Read browsing history',
    desc_zh: '读取浏览记录'
  },
  {
    name: 'Web.Delete.WebObject.040',
    count: 0,
    desc_en: 'Delete Webkit cache',
    desc_zh: '删除Webkit缓存'
  },
  {
    name: 'Web.Read.WebObject.050',
    count: 1,
    desc_en: 'Read submitted from data',
    desc_zh: '从数据读取Submitted'
  },
  {
    name: 'Web.Write.WebObject.050',
    count: 2,
    desc_en: 'Insert sumbmitted from data',
    desc_zh: '擦写数据到Submitted'
  },
  {
    name: 'Web.Delete.WebObject.050',
    count: 2,
    desc_en: 'Delete submitted from data',
    desc_zh: '从Submitted中删除数据'
  },
  {
    name: 'Web.Read.WebObject.060',
    count: 1,
    desc_en: 'Read browser cookies',
    desc_zh: '读取浏览器Cookies'
  },
  {
    name: 'Web.Write.WebObject.060',
    count: 1,
    desc_en: 'Insert browser cookies',
    desc_zh: '插入浏览器Cookies'
  },
  {
    name: 'Web.Delete.WebObject.060',
    count: 1,
    desc_en: 'Delete browser cookies',
    desc_zh: '删除浏览器Cookies'
  },
  {
    name: 'Web.Read.WebObject.070',
    count: 1,
    desc_en: 'Read browser bookmarks',
    desc_zh: '读取浏览器书签'
  },
  {
    name: 'Web.Write.WebObject.070',
    count: 2,
    desc_en: 'Insert browser bookmarks',
    desc_zh: '擦写浏览器书签'
  },
  {
    name: 'Web.Delete.WebObject.070',
    count: 2,
    desc_en: 'Delete browser bookmarks',
    desc_zh: '删除浏览器书签'
  },
  {
    name: 'Web.Read.WebObject.080',
    count: 1,
    desc_en: 'Read Webkit user agent',
    desc_zh: '读取Webkit用户代理信息'
  },
  {
    name: 'Web.Write.WebObject.090',
    count: 1,
    desc_en: 'Set Webkit browser private mode',
    desc_zh: '设置Webkit浏览器私人模式'
  },
  {
    name: 'Web.Write.WebObject.100',
    count: 1,
    desc_en: 'Set Webkit property',
    desc_zh: '设置Webkit优先级'
  },
  {
    name: 'Web.Read.File.000',
    count: 0,
    desc_en: 'Load local file with URL',
    desc_zh: '加载带URL的本地文件'
  },
  {
    name: 'Web.Read.File.001',
    count: 0,
    desc_en: 'Load remote URL',
    desc_zh: '加载远程URL'
  },
  {
    name: 'Android.Create.UI.000',
    count: 0,
    desc_en: 'Create the shortcut on the Home screen',
    desc_zh: '在主界面创建快捷方式'
  },
  {
    name: 'Android.Set.AudioMute.000',
    count: 0,
    desc_en: 'Mute device',
    desc_zh: '开启设备静音'
  },
  {
    name: 'Android.Write.SysSetting.000',
    count: 0,
    desc_en: 'Set APN network (when no wifi)',
    desc_zh: '设置APN网络 (当没有wifi的时候)'
  },
  {
    name: 'Android.Read.Network.000',
    count: 0,
    desc_en: 'Get wifi networks',
    desc_zh: '获取wifi网络'
  },
  {
    name: 'Android.Write.SysSetting.010',
    count: 0,
    desc_en: 'Change wifi: disable',
    desc_zh: '关闭wifi'
  },
  {
    name: 'Android.Write.SysSetting.011',
    count: 0,
    desc_en: 'Change wifi: enable',
    desc_zh: '开启wifi'
  },
  {
    name: 'Android.Write.Broadcast.000',
    count: 2,
    desc_en: 'Push notifications',
    desc_zh: '推送提醒'
  },
  {
    name: 'Android.Write.UI.000',
    count: 1,
    desc_en: 'Screenshot',
    desc_zh: '截屏'
  },
  {
    name: 'Android.Apply.DeviceAdmin.900',
    count: 0,
    desc_en: 'Apply device admin',
    desc_zh: '申请设备管理员权限'
  },
  {
    name: 'Android.Write.AudioFile.000',
    count: 0,
    desc_en: 'Set device audio source',
    desc_zh: '设置设备音频源'
  },
  {
    name: 'Android.Read.HardwareAudio.000',
    count: 3,
    desc_en: 'Sound recording',
    desc_zh: '激活麦克风并记录'
  },
  {
    name: 'Android.Read.HardwareVideo.000',
    count: 3,
    desc_en: 'Camera recording',
    desc_zh: '激活摄像头并记录'
  },
  {
    name: 'Android.Read.Location.000',
    count: 2,
    desc_en: 'Read device location',
    desc_zh: '读取设备定位信息'
  },
  {
    name: 'Android.Read.SysSetting.000',
    count: 1,
    desc_en: 'Read device configuration',
    desc_zh: '读取设备设备构造'
  },
  {
    name: 'Android.Read.SysSetting.001',
    count: 1,
    desc_en: 'Read IMEI number',
    desc_zh: '读取 IMEI 号码'
  },
  {
    name: 'Android.Read.SysSetting.002',
    count: 1,
    desc_en: 'Read IMEI SV number',
    desc_zh: '读取 IMEI SV 号码'
  },
  {
    name: 'Android.Read.SysSetting.003',
    count: 1,
    desc_en: 'Read ESN ID',
    desc_zh: '读取 ESN ID 信息'
  },
  {
    name: 'Android.Read.SysSetting.004',
    count: 1,
    desc_en: 'Read phone ISIM/LMPI number',
    desc_zh: '读取手机 ISIM/LMPI 号码'
  },
  {
    name: 'Android.Read.SysSetting.005',
    count: 1,
    desc_en: 'Read phone alpha tag number',
    desc_zh: '读取手机alpha标签号码'
  },
  {
    name: 'Android.Read.SysSetting.006',
    count: 1,
    desc_en: 'Read voice mail alpha tag number',
    desc_zh: '读取语音信箱alpha标签号码'
  },
  {
    name: 'Android.Read.SysSetting.007',
    count: 1,
    desc_en: 'Read phone Msisdn number',
    desc_zh: '读取手机 Msisdn 号码'
  },
  {
    name: 'Android.Read.SysSetting.008',
    count: 1,
    desc_en: 'Read device ID',
    desc_zh: '读取设备ID'
  },
  {
    name: 'Android.Read.SysSetting.009',
    count: 1,
    desc_en: 'Read X509 public key',
    desc_zh: '读取 X509 公开密匙'
  },
  {
    name: 'Android.Read.Account.000',
    count: 2,
    desc_en: 'Read device account information',
    desc_zh: '读取设备账号信息'
  },
  {
    name: 'Android.Read.Email.000',
    count: 2,
    desc_en: 'Read email info',
    desc_zh: '读取邮件信息'
  },
  {
    name: 'Android.Write.Email.000',
    count: 3,
    desc_en: 'Insert email',
    desc_zh: '擦写邮件'
  },
  {
    name: 'Android.Delete.Email.000',
    count: 3,
    desc_en: 'Delete email',
    desc_zh: '删除邮件'
  },
  {
    name: 'Android.Read.SysSetting.011',
    count: 1,
    desc_en: 'Read device setting info',
    desc_zh: '读取设备设置信息'
  },
  {
    name: 'Android.Terminate.HardwareGeneric.900',
    count: 3,
    desc_en: 'Shutdown device',
    desc_zh: '关闭设备'
  },
  {
    name: 'Android.Delete.Receiver.000',
    count: 2,
    desc_en: 'Unregister receiver',
    desc_zh: '反注册接收器'
  },
  {
    name: 'Android.Write.SysSetting.020',
    count: 2,
    desc_en: 'Add application as preferred',
    desc_zh: '添加应用到喜欢应用列表'
  },
  {
    name: 'Android.Delete.File.000',
    count: 2,
    desc_en: 'Remove application user data',
    desc_zh: '删除应用用户数据'
  },
  {
    name: 'Android.Delete.File.001',
    count: 2,
    desc_en: 'Remove application cache file',
    desc_zh: '删除应用缓存文件'
  },
  {
    name: 'Android.Apply.ReflectFunction.000',
    count: 0,
    desc_en: 'Call the function indirectly by reflecting method',
    desc_zh: '使用映射方式间接调用某些功能'
  },
  {
    name: 'Evade.Timer.000',
    count: 0,
    desc_en: 'Timer trigger / Delay',
    desc_zh: '激活/延迟 时间设置'
  },
  {
    name: 'Evade.Sandbox.000',
    count: 0,
    desc_en: 'Sandbox detection',
    desc_zh: '沙盒检测'
  },
  {
    name: 'Exploit.JsInterface.000',
    count: 0,
    desc_en: 'Add Java script interface',
    desc_zh: '添加Java编译连接器'
  },
  {
    name: 'Exploit.Encrypt.Package.000',
    count: 3,
    desc_en: 'Prevent device admin deactivation',
    desc_zh: '防止设备停止管理员账户'
  },
  {
    name: 'Exploit.StealBy.Package.000',
    count: 3,
    desc_en: 'Rooting (generic)',
    desc_zh: 'Rooting (通用)'
  },
  {
    name: 'Process.Read.Process',
    count: 1,
    desc_en: 'Get running process',
    desc_zh: '获取运行中进程'
  },
  {
    name: 'Android.Read.Loc.000',
    count: 0,
    desc_en: 'Read device location',
    desc_zh: '获取地理位置'
  },
  {
    name: 'Network.Write.File.000',
    count: 2,
    desc_en: 'Download file',
    desc_zh: '下载文件'
  },
  {
    name: 'File.Read.ContentProvider',
    count: 1,
    desc_en: 'Read from content provider',
    desc_zh: '读取ContentProvider数据'
  },
  {
    name: 'File.Del.ContentProvider',
    count: 0,
    desc_en: 'Delete phone data',
    desc_zh: '删除本地数据'
  },
  {
    name: 'Android.Apply.ReflectFunction',
    count: 2,
    desc_en: 'Call the function indirectly by reflecting method',
    desc_zh: '使用映射方式间接调用某些功能'
  },
  {
    name: 'Android.Read.SysSetting',
    count: 0,
    desc_en: 'Read device setting info',
    desc_zh: '读取设备设置信息'
  },
  {
    name: 'Comm.Read.PhoneInfo',
    count: 0,
    desc_en: 'Read phone information',
    desc_zh: '读取手机信息'
  },
  {
    name: 'Evade.Timer',
    count: 1,
    desc_en: 'Timer trigger / Delay',
    desc_zh: '激活/延迟 时间设置'
  },
  {
    name: 'Privilege.Apply.DeviceAdmin',
    count: 3,
    desc_en: 'Apply device admin privilege',
    desc_zh: '申请设备管理员权限'
  },
  {
    name: 'File.Write.File.000',
    count: 1,
    desc_en: 'Write file',
    desc_zh: '写入文件'
  },
  {
    name: 'Comm.DELETE.SMS.200',
    count: 3,
    desc_en: 'Delete from SMS inbox',
    desc_zh: '删除短信收件箱内的文件'
  },
  {
    name: 'Comm.DELETE.PhoneCall.100',
    count: 0,
    desc_en: 'Delete call history',
    desc_zh: '删除通话记录'
  },
  {
    name: 'File.Encrypt.File.001',
    count: 1,
    desc_en: 'Encrypt file',
    desc_zh: '加密文件'
  },
  {
    name: 'File.Encrypt.File.002',
    count: 2,
    desc_en: 'Encrypt file using secretKeySpec class',
    desc_zh: '使用secretKeySpec类加密文件'
  },
  {
    name: 'File.Encrypt.File.003',
    count: 2,
    desc_en: 'Encrypt file using cipher class',
    desc_zh: '使用cipher类加密文件'
  },
  {
    name: 'Android.Delete.UI',
    count: 0,
    desc_en: 'Delete Screenshot',
    desc_zh: '删除截屏'
  },
  {
    name: 'File.Update.ContentProvider',
    count: 0,
    desc_en: 'Modify ContentProvider',
    desc_zh: '修改ContentProvider'
  },
  {
    name: 'Android.Install.Package.004',
    count: 0,
    desc_en: 'Get the app installment broadcast',
    desc_zh: '获取安装软件广播'
  },
  {
    name: 'Android.Install.Package.003',
    count: 0,
    desc_en: 'Get the app installment broadcast',
    desc_zh: '获取安装软件广播'
  },
  {
    name: 'Android.Install.Package.002',
    count: 0,
    desc_en: 'Get the app installment broadcast',
    desc_zh: '获取安装软件广播'
  },
  {
    name: 'Android.Install.Package.001',
    count: 0,
    desc_en: 'Get the app installment broadcast',
    desc_zh: '获取安装软件广播'
  },
  {
    name: 'Android.Install.Package.000',
    count: 0,
    desc_en: 'Get the app installment broadcast',
    desc_zh: '获取安装软件广播'
  },
  {
    name: 'Android.Change.Package',
    count: 0,
    desc_en: 'Change other apps (such as disable or enable other Apps)',
    desc_zh: '修改其它软件 (比如关闭或开启)'
  },
  {
    name: 'Android.Replace.Package',
    count: 0,
    desc_en: 'Replace other apps',
    desc_zh: '替换其他软件'
  },
  {
    name: 'Android.Write.AudioFile',
    count: 0,
    desc_en: 'Set device audio source',
    desc_zh: '设置设备音频源'
  },
  {
    name: 'Android.Set.AudioMute',
    count: 0,
    desc_en: 'Mute device',
    desc_zh: '开启设备静音'
  },
  {
    name: 'Android.Read.Account',
    count: 2,
    desc_en: 'Read device account information',
    desc_zh: '读取设备账号信息'
  },
  {
    name: 'Android.Write.SysSetting',
    count: 0,
    desc_en: 'Set APN network (when no wifi)',
    desc_zh: '设置APN网络 (当没有wifi的时候)'
  },
  {
    name: 'Android.Write.UI.000',
    count: 1,
    desc_en: 'Screenshot',
    desc_zh: '截屏'
  },
  {
    name: 'File.Read.ContentProvider.524288',
    count: 1,
    desc_en: 'Read Content Provider',
    desc_zh: '读取Content Provider'
  },
  {
    name: 'File.Write.ContentProvider.000',
    count: 0,
    desc_en: 'Add Call Log',
    desc_zh: '添加通话记录'
  },
  {
    name: 'Comm.Write.Sms.203',
    count: 3,
    desc_en: 'Send SMS',
    desc_zh: '发送短信'
  },
  {
    name: 'Android.SetPrivilege.DeviceAdmin.000',
    count: 0,
    desc_en: 'Activate Device Policy',
    desc_zh: '激活设备管理员'
  },
  {
    name: 'Android.RemovePrivilege.DeviceAdmin.000',
    count: 0,
    desc_en: 'Deactivate Device Policy',
    desc_zh: '取消设备管理员'
  },
  {
    name: 'Android.Update.PowerStatus.000',
    count: 0,
    desc_en: 'Power Connected',
    desc_zh: '连接电源'
  },
  {
    name: 'Android.Update.PowerStatus.001',
    count: 0,
    desc_en: 'Power Disconnected',
    desc_zh: '断开电源'
  },
  {
    name: 'Process.Exec.Process.004',
    count: 0,
    desc_en: 'Start Activity With Power Status',
    desc_zh: '充电屏'
  },
  {
    name: 'Android.Read.Camera.001',
    count: 3,
    desc_en: 'Camera Actions',
    desc_zh: '拍照'
  },
  {
    name: 'Android.Read.Camera.000',
    count: 2,
    desc_en: 'Camera Actions',
    desc_zh: '拍照预览'
  },
  {
    name: 'Android.Read.SysSetting.010',
    count: 1,
    desc_en: 'WiFi Credentials',
    desc_zh: '获取WIFI连接信息'
  },
  {
    name: 'Android.Write.Ui.002',
    count: 0,
    desc_en: 'A view Has Top UI layer Property',
    desc_zh: '悬浮窗'
  },
  {
    name: 'Android.Update.PowerStatus.002',
    count: 0,
    desc_en: 'Device Goes To Sleep',
    desc_zh: '设备休眠'
  },
  {
    name: 'Android.Update.PowerStatus.003',
    count: 0,
    desc_en: 'Device Wakes Up',
    desc_zh: '设备唤醒'
  },
  {
    name: 'Android.Read.SysSetting.012',
    count: 1,
    desc_en: 'Read MAC Address',
    desc_zh: '读取网络物理地址'
  },
  {
    name: 'Android.Read.SysSetting.008',
    count: 1,
    desc_en: 'Read ANDROID_ID',
    desc_zh: '读取ANDROID ID'
  },
  {
    name: 'Android.Write.Ui.001',
    count: 0,
    desc_en: 'Remove Window',
    desc_zh: '删除悬浮窗'
  },
  {
    name: 'Android.Evade.Timer.001',
    count: 0,
    desc_en: 'Timer',
    desc_zh: '定时器设置'
  },
  {
    name: 'Android.Evade.Timer.002',
    count: 0,
    desc_en: 'Sleep',
    desc_zh: '线程休眠'
  },
  {
    name: 'Android.Evade.Timer.003',
    count: 0,
    desc_en: 'Delayed Task Running',
    desc_zh: '延迟启动任务'
  },
  {
    name: 'Comm.Add.SMS.200',
    count: 1,
    desc_en: 'Add SMS',
    desc_zh: '写入短信'
  },
  {
    name: 'Comm.Add.PhoneCall.100',
    count: 1,
    desc_en: 'Add Call Log',
    desc_zh: '写入通话记录'
  },
  {
    name: 'Comm.Add.Contact.100',
    count: 1,
    desc_en: 'Add Contacts',
    desc_zh: '添加通讯录'
  },
  {
    name: 'Comm.Update.SMS.200',
    count: 1,
    desc_en: 'Update SMS',
    desc_zh: '更添新短信'
  },
  {
    name: 'Comm.Update.Contact.100',
    count: 1,
    desc_en: 'Update Call Log',
    desc_zh: '更新通讯录'
  },
  {
    name: 'Comm.Delete.Contact.100',
    count: 2,
    desc_en: 'Delete Contacts',
    desc_zh: '删除通讯录'
  },
  {
    name: 'File.Read.ContentProvider.33554432',
    count: 1,
    desc_en: 'Read Content Provider',
    desc_zh: '读取Content Provider'
  },
  {
    name: 'File.Read.ContentProvider.512',
    count: 1,
    desc_en: 'Read Content Provider',
    desc_zh: '读取Content Provider'
  },
  {
    name: 'File.Read.ContentProvider.001',
    count: 3,
    desc_en: 'Read Contacts',
    desc_zh: '读取联系人'
  },
  {
    name: 'File.Read.ContentProvider.002',
    count: 3,
    desc_en: 'Read Call log',
    desc_zh: '读取通话记录'
  },
  {
    name: 'File.Read.ContentProvider.003',
    count: 3,
    desc_en: 'Read SMS',
    desc_zh: '读取短信'
  },
  {
    name: 'Process.Exec.Process.3',
    count: 1,
    desc_en: 'Launch service',
    desc_zh: '开启服务'
  },
  {
    name: 'Process.Exec.Activity.000',
    count: 2,
    desc_en: 'Activity Creation',
    desc_zh: 'Activity创建'
  }
]

export default SummaryList



// WEBPACK FOOTER //
// ./src/views/public/summaryList.js